// Depends
import { route, group, subGroup, meta } from '@/helpers/routes'

import Index from './index/index'

const CommonAreaRoutes = [
  route('index', '/index', Index, meta('Lista de Áreas Comuns', true, 'guest'))
]

export default [
  ...group('/app', [
    ...subGroup('/common-area', CommonAreaRoutes)
  ])
]



// WEBPACK FOOTER //
// ./src/app/tenant/common-area/routes.js